import { Modal, useModal } from "~/components";
import UnlimitedOfferContent from "~/components/unlimited-offer-content";

// Minimal curiosity teaser for the chat-screen header icon row: a small CSS
// gift box (black + red ribbon/bow, matching the offer creative) + an amber
// attention dot, with a "Bonus" label on desktop (hidden on mobile). Built in
// CSS — no image asset. Opens the reward popup; the header only renders it for
// eligible users with no active window.
export default function UnlimitedBonusTeaser() {
  const offerModal = useModal();

  return (
    <>
      <div
        role="button"
        tabIndex={0}
        onClick={offerModal.open}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            offerModal.open();
          }
        }}
        aria-label="See your unlocked bonus"
        className="flex flex-col items-center cursor-pointer hover:scale-105 transform transition-transform duration-300"
      >
        {/* Sized to draw ~20px of ink, matching the bell / gift / coin beside it.
            Ink runs from the bow top (y=6) to the box bottom (y=26) inside the
            36px row. The old -translate-y-[6px] nudge is gone: it was hand-tuned
            against the previous oversized box and now pushes it out of line. */}
        <div className="relative flex h-9 items-center justify-center">
          {/* 17px wide, matching the bell's 17.9px ink width — the box used to be
              24px (full width of its container) and read as a wide slab. */}
          <div className="relative h-9 w-[17px]" aria-hidden>
            {/* bow — rests on the box's top edge */}
            <div className="absolute left-1/2 top-[7px] z-10 flex -translate-x-1/2 gap-[1px]">
              <span className="h-[4px] w-[4px] -rotate-[20deg] rounded-full bg-gradient-to-br from-red-400 to-red-600" />
              <span className="h-[4px] w-[4px] rotate-[20deg] rounded-full bg-gradient-to-bl from-red-400 to-red-600" />
            </div>
            {/* box + vertical ribbon, centered on the row line. Glow cut from 8px
                to 3px: a solid filled shape already reads heavier than the hollow
                line icons beside it, and an 8px halo added ~16px of apparent width. */}
            <div className="absolute inset-x-0 top-1/2 h-[14px] -translate-y-1/2 overflow-hidden rounded-[3px]
                            bg-gradient-to-b from-neutral-700 via-neutral-900 to-black
                            ring-1 ring-red-500/40 shadow-[0_0_3px_rgba(255,40,40,0.35)]">
              <span className="absolute inset-y-0 left-1/2 w-[3px] -translate-x-1/2 bg-gradient-to-b from-red-500 to-red-700" />
            </div>
          </div>
          {/* attention dot — anchored to the box's top-right */}
          <span className="absolute right-0 top-[6px] h-1.5 w-1.5 rounded-full bg-amber-400 ring-2 ring-headerBackground animate-pulse" />
        </div>
        <span className="hidden md:block text-text text-[0.5rem] -mt-0.5 font-semibold">
          Bonus
        </span>
      </div>

      <Modal {...offerModal.modalProps} subtleClose>
        <UnlimitedOfferContent />
      </Modal>
    </>
  );
}
